import React from 'react';
import fr from 'facet-rest';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import LayoutContainer from './LayoutContainer';

const LayoutWrapper = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <IncludedRelationshipProvider
      relationship={resource.relationship(fr.relationships.effects.name)}
    >
      <LayoutContainer />
    </IncludedRelationshipProvider>
  );
};

LayoutWrapper.propTypes = {};

export default LayoutWrapper;
